module.exports = __webpack_public_path__ + "static/media/SimplePromptingExampleImage.38aef0ee.png";